// @flow

import { isPlainObject } from 'lodash';

export const assignForcedObject = (object: mixed, assign: {}): {} => {
  return {
    ...(isPlainObject(object) ? object : {}),
    ...assign,
  };
};

export const setInForcedObject = (
  object: mixed,
  key: string,
  value: mixed
): {} => {
  return assignForcedObject(object, {
    [key]: value,
  });
};

export const getFromForcedObject = (object: mixed, key: string): mixed => {
  if (!isPlainObject(object)) {
    return undefined;
  }
  return object[key];
};
